import { BaseService } from '../../infra/base.service'
import type { QuotationEntity } from './quotation.entity'
import type { QuotationsRepository } from './quotations.repository'

export class QuotationsService extends BaseService<QuotationEntity> {
    constructor(private rep: QuotationsRepository) {
        super(rep)
    }

    async upsert(dto: Partial<QuotationEntity>) {
        return await this.rep.upsert(dto)
    }

    async setPaid(appointmentId: string, dto: { invoiceId: string }) {
        return await this.rep.setPaid(appointmentId, dto)
    }

    async setUnpaid(appointmentId: string) {
        return await this.rep.setUnpaid(appointmentId)
    }
}
